import { cn } from '#/lib/utils';

import { avatarPillLabels } from '../content';
import { UserProfileCircleIcon } from './UserProfileCircleIcon';

export function AvatarBlock({ activeButton }: { activeButton: number }) {
  return (
    <div className="flex items-center justify-center">
      {/* h-[320px] is shared with InitiativesBlock so both cards match */}
      <div className="bg-charcoal border-grayscale-04 border-1 rounded-22 px-27 py-30 flex flex-col gap-17 w-[280px] h-[320px] items-center">
        <div className="flex gap-4 text-cloud">
          <UserProfileCircleIcon className="size-48" />
          <UserProfileCircleIcon className="size-48" />
          <UserProfileCircleIcon className="size-48" />
        </div>
        <div className="flex flex-col gap-11 w-full">
          {avatarPillLabels.map((item, index) => (
            <div
              key={index}
              className={cn(
                'avatar-button h-40 rounded-6 border-grayscale-05 text-cloud border-1 flex items-center justify-center p-8 px-4 w-full min-w-180 transition-colors duration-300',
                activeButton === index && 'text-electric-05 border-electric-05',
              )}
            >
              <span className="text-12 font-[500] leading-140 text-current">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
